var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.page < _vm.totalPages)?_c('v-col',{staticClass:"text-center mt-2",attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"ma-2",attrs:{"outlined":"","color":_vm.colorSet.norbitPrimary,"tile":""},domProps:{"innerHTML":_vm._s(_vm.buttonText)},on:{"click":function($event){return _vm.$emit('loadMoreProducts')}}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }